import { useCurriculumStore as useCourseCurriculumStore, prepareCurriculumStorePersistenceForCourse } from '@edusense/entities-course';
// features 레이어에서 사용할 수 있도록 래핑
export const useCurriculumStore = useCourseCurriculumStore;
export const ensureCurriculumStorePersistenceForCourse = prepareCurriculumStorePersistenceForCourse;
